// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, ROLES } from './context/AuthContext';
import { DataCacheProvider } from './context/DataCacheContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import RoleBasedRoute from './components/RoleBasedRoute/RoleBasedRoute';
import Layout from './components/Layout/Layout';
import Login from './components/Login/Login';
import MainPage from './components/MainPage/MainPage';
import TrainingEvents from './components/TrainingEvents/TrainingEvents';
import HeatMap from './components/HeatMap/HeatMap';
import Settings from './components/Settings/Settings';
import EmployeeTrainings from './components/Settings/EmployeeTrainings';
import TrainingEventDetail from './components/TrainingEvents/TrainingEventDetail';
import MyTrainings from './components/MyTrainings/MyTrainings';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <DataCacheProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              {/* Главная страница - для всех */}
              <Route index element={<MainPage />} />
              
              {/* Мои обучения - ТОЛЬКО для пользователей */}
              <Route path="my-trainings" element={
                <RoleBasedRoute requiredRoles={[ROLES.USER]}>
                  <MyTrainings />
                </RoleBasedRoute>
              } />
              
              {/* Мероприятия - для всех кроме USER */}
              <Route path="events" element={
                <RoleBasedRoute excludeRoles={[ROLES.USER]}>
                  <TrainingEvents />
                </RoleBasedRoute>
              } />
              <Route path="training-events/:id" element={
                <RoleBasedRoute excludeRoles={[ROLES.USER]}>
                  <TrainingEventDetail />
                </RoleBasedRoute>
              } />
              
              {/* Тепловая карта - для всех кроме USER */}
              <Route path="heatmap" element={
                <RoleBasedRoute excludeRoles={[ROLES.USER]}>
                  <HeatMap />
                </RoleBasedRoute>
              } />
              
              {/* Настройки - для всех кроме USER */}
              <Route path="settings" element={
                <RoleBasedRoute excludeRoles={[ROLES.USER]}>
                  <Settings />
                </RoleBasedRoute>
              } />
              
              {/* Обучения сотрудника - для всех кроме USER */}
              <Route path="settings/employees/:employeeId/trainings" element={
                <RoleBasedRoute excludeRoles={[ROLES.USER]}>
                  <EmployeeTrainings />
                </RoleBasedRoute>
              } />
              
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </DataCacheProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;